import axios, { AxiosInstance } from 'axios';
import { setRefreshToken } from 'utilities/AuthService';

const apiUrl = import.meta.env.VITE_APP_RULES_ENGINE_API_URL ? import.meta.env.VITE_APP_RULES_ENGINE_API_URL : 'https://localhost:5001/';

export const useApiWorker = (): AxiosInstance => {
  const apiWorker = axios.create({
    baseURL: apiUrl,
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
  apiWorker.interceptors.request.use(
    async (config) => {
      if (!(config.url?.includes('login') || config.url?.includes('refreshToken'))) await setRefreshToken();
      return config;
    },
    (error) => {
      // Do something with request error
      return Promise.reject(error);
    },
  );
  return apiWorker;
};

export default useApiWorker;
